import { ICONS } from 'Components/utils/icon/icons';
import { getCursorClass } from 'Components/utils/form/form.util';
import { classnames } from 'Utils/classnames/classnames.utils';

export const themes = {
  default: (props) => {
    const {
      hasValidationIcon,
      isActive,
      isDisabled,
      isFilled,
      isReadOnly,
      validationState = 'NOT_VALIDATED',
    } = props;

    const hasDefaultStyle =
      validationState === 'NOT_VALIDATED' && !isActive && !isFilled && !isDisabled;
    const hasValidStyle = validationState === 'IS_VALID' && !isFilled && !isDisabled && !isReadOnly;
    const hasInvalidStyle =
      validationState === 'IS_INVALID' && !isFilled && !isDisabled && !isReadOnly;

    let validationIconName = null;

    if (hasValidationIcon && (hasValidStyle || hasInvalidStyle)) {
      validationIconName = hasValidStyle ? ICONS.CHECK : ICONS.CROSS;
    }

    return {
      thField: classnames(
        'flex items-center gap-10',
        getCursorClass(props),
        'h-48 w-full appearance-none rounded-pill border bg-white px-20 py-10 text-14 leading-normal text-black outline-none transition-all duration-250 ease-in',
        {
          'border-lightGrey hocus:border-black': hasDefaultStyle,
          'border-success': hasValidStyle,
          'formik-errored border-red': hasInvalidStyle,
          'cursor-not-allowed border-grey bg-pearl': isDisabled || isReadOnly,
          'text-grey': isDisabled,
        },
      ),
      thSpinner: 'text-current',
      thClearButton: 'leading-0 transition-color',
      thClearIconSize: '0.625rem',
      thValidationIcon: hasValidStyle ? 'text-success' : 'text-red',
      thValidationIconSize: '0.8125rem',
      thValidationIconName: validationIconName,
    };
  },
};
